export class MembershipListConfig {
  limit?: number;
  offset?: number;
}
